<div class="wrapper-modal p-4">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <form [formGroup]="satelliteLockForm" (ngSubmit)="assignSatelliteLock()">
        <h2 class="text-bold text-center mb-4"> Asignación de candado satelital</h2>
        <div class="field-container">

            <div class="mb-3" *ngIf="satelliteLockTypeName">
                <label class="text-bold">Tipo de candado satelital:</label>
                <span class="ml-2">{{ satelliteLockTypeName }}</span>
            </div>

            <app-autocomplete-satellite-lock class="w-100" [inputFormControl]="satelliteLockControl"
                [options]="optionsSatelliteLock" [validate]="formValidate">
            </app-autocomplete-satellite-lock>

            <div class="selected-lock-info mt-3" *ngIf="selectedSatelliteLock">
                <div class="card" [ngClass]="getStateDevice().class">
                    <div>
                        <strong>ID:</strong> {{ selectedSatelliteLock.id || '-' }}
                    </div>
                    <div>
                        <strong>Consecutivo:</strong> {{ selectedSatelliteLock.consecutive ?
                        (selectedSatelliteLock.consecutive |
                        uppercase) : '-' }}
                    </div>
                    <div>
                        <strong>Estado del dispositivo:</strong> {{ getStateDevice().text }}
                    </div>
                </div>
            </div>
        </div>

        <div class="button-container mt-4">
            <button type="button" mat-raised-button class="primary-secondary" color="primary"
                (click)="dialogRef.close()">
                Cancelar
            </button>
            <button type="submit" mat-raised-button color="primary" class="bg-color-primary">
                Asignar
            </button>
        </div>
    </form>
</div>